import { Box, Button, Center, Flex, HStack, Image, Link, Spacer, Text } from '@chakra-ui/react'
import { AppContainer } from 'components/ui/appContainer'
import { CustomHeading } from 'components/ui/customHeading'
import { NextLink } from 'components/wrapper/nextLink'
import { FC } from 'react'
import { Routes } from 'routes'

export const LpPage: FC = () => {
  return (
    <>
      <AppContainer>
        <HStack spacing={4} justify="center">
          <Box pl={6}>
            <Image src="/assets/logo.svg" w="276px" h="auto" />
            <Spacer mt={10} />
            <Text fontSize={24} lineHeight="45px">
              旅行手配に、いつもいる。
              <br />
              あなたに寄り添うホテル予約サービス。
            </Text>
            <Spacer mt={12} />
            <Link as={NextLink} href={Routes.signUp()}>
              <HStack spacing={2}>
                <Image src="/assets/arrow_right_circle.svg" boxSize={4} />
                <Text fontSize={14} lineHeight={1}>
                  新規会員登録へ
                </Text>
              </HStack>
            </Link>
          </Box>
          <Image src="/assets/pages/lp/main.svg" w="696px" h="480px" />
        </HStack>

        <Spacer mt={44} />

        <Box>
          <Center>
            <CustomHeading as="h2">HoteCoの特徴</CustomHeading>
          </Center>
          <Spacer mt={'104px'} />
          <HStack align={'flex-start'} spacing={'75px'}>
            <Flex flexDirection="column" align="center" flex={1}>
              <Image src="/assets/pages/lp/feature1.svg" w="auto" h="160px" />
              <Text fontSize={24} lineHeight="36px" fontWeight="bold" mt={6}>
                豊富なホテル在庫
              </Text>
              <Text fontSize={18} lineHeight="27px" mt={5}>
                競争力のある価格と世界中の65万軒以上の宿泊施設をご用意！
              </Text>
            </Flex>
            <Flex flexDirection="column" align="center" flex={1}>
              <Image src="/assets/pages/lp/feature2.svg" w="auto" h="160px" />
              <Text fontSize={24} lineHeight="36px" fontWeight="bold" mt={6}>
                安心のサポート
              </Text>
              <Text fontSize={18} lineHeight="27px" mt={5}>
                ランドオペレーター経験のあるスタッフが対応する安心体制！
                <br />
                緊急時には24時間対応も可能です。
              </Text>
            </Flex>
            <Flex flexDirection="column" align="center" flex={1}>
              <Image src="/assets/pages/lp/feature3.svg" w="auto" h="160px" />
              <Text fontSize={24} lineHeight="36px" fontWeight="bold" mt={6}>
                請求書精算に対応可能
              </Text>
              <Text fontSize={18} lineHeight="27px" mt={5}>
                精算は、クレジットカード決済が基本となりますが、請求書での精算も可能です。
                <br />
                （※ご利用には審査が必要です。）
              </Text>
            </Flex>
          </HStack>
          <Spacer mt={'112px'} />
          <Center>
            <Button as={NextLink} href={Routes.signUp()} w="346px">
              新規会員登録
            </Button>
          </Center>
        </Box>
        <Spacer mt={'396px'} />
      </AppContainer>
    </>
  )
}
